"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = exports.CHECKBOX_SIZES = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var hooks_1 = require("../../../mantine-hooks/src");
var theme_1 = require("../../../mantine-theme/src");
var CheckboxIcon_1 = require("./CheckboxIcon");
var Checkbox_styles_1 = __importStar(require("./Checkbox.styles"));
exports.CHECKBOX_SIZES = Checkbox_styles_1.sizes;
function Checkbox(_a) {
    var className = _a.className, checked = _a.checked, onChange = _a.onChange, color = _a.color, themeOverride = _a.themeOverride, label = _a.label, disabled = _a.disabled, intermediate = _a.intermediate, id = _a.id, size = _a.size, wrapperProps = _a.wrapperProps, style = _a.style, inputStyle = _a.inputStyle, inputClassName = _a.inputClassName, elementRef = _a.elementRef, others = __rest(_a, ["className", "checked", "onChange", "color", "themeOverride", "label", "disabled", "intermediate", "id", "size", "wrapperProps", "style", "inputStyle", "inputClassName", "elementRef"]);
    var uuid = hooks_1.useId(id);
    var classes = Checkbox_styles_1.default({ size: size, color: color, theme: theme_1.useMantineTheme(themeOverride) });
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.wrapper, className), style: style }, wrapperProps),
        react_1.default.createElement("div", { className: classes.checkboxWrapper },
            react_1.default.createElement("input", __assign({}, others, { id: uuid, ref: elementRef, type: "checkbox", className: clsx_1.default(classes.checkbox, inputClassName), checked: intermediate || checked, onChange: onChange, disabled: disabled, style: inputStyle })),
            react_1.default.createElement(CheckboxIcon_1.CheckboxIcon, { intermediate: intermediate, className: classes.icon })),
        label && (react_1.default.createElement("label", { className: classes.label, htmlFor: uuid }, label))));
}
exports.Checkbox = Checkbox;
Checkbox.displayName = '@mantine/core/Checkbox';
